const timeOptions = {
    timeZone: 'Asia/Jerusalem',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
};
const dateOptions = {
    timeZone: 'Asia/Jerusalem',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
};

export const getIsraelTime = () => {
    return new Intl.DateTimeFormat('en-GB', timeOptions).format(new Date());
};

export const getIsraelDate = () => {
    return new Intl.DateTimeFormat('en-GB', dateOptions).format(new Date());
};
